import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';
import 'react-native-url-polyfill/auto';

import { firebaseConfig } from './firebaseConfig';

let app: FirebaseApp;
let db: Firestore;

function initApp(): FirebaseApp {
  if (getApps().length === 0) {
    return initializeApp(firebaseConfig);
  }
  return getApps()[0]!;
}

export function getFirebaseApp(): FirebaseApp {
  if (!app) {
    app = initApp();
  }
  return app;
}

export function getFirestoreDb(): Firestore {
  if (!db) {
    db = getFirestore(getFirebaseApp());
  }
  return db;
}
